const LOCAL_SERVER_HOST_NAME = 'localhost'

export { LOCAL_SERVER_HOST_NAME }
